import categoriesMutations from "./mutations.js";
import categoriesActions from "./actions.js";
import categoriesGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            categories: {},
            treeSelectedItem: {},
            selectedCategoryIdInBrowse: "",
            rootCategoryDetails:{}
        };
    },
    mutations: categoriesMutations,
    actions: categoriesActions,
    getters: categoriesGetters,
};